import "./auth.scss";
import React from "react";
import VerificationForm from "../../components/Forms/AuthForms/VerificationForm";
import onco_mark from "../../assets/logos/ONCOEVIDA.svg";

const Verification = () => {
  return (
    <div className="myCustomLogin">
      <div className="logoPart container">
        <div className="logoContainer">
          <img src={onco_mark} alt="" />
        </div>
      </div>
      <div className="formPart">
        <div className="contact">
          <VerificationForm />
        </div>
      </div>
    </div>
  );
};

export default Verification;
